export default function () {
  const widgetName = 'cardsWidget';
  const widgetOpts = cardsWidgetOpts;

  let windowSize = $(window).width();
  let breakpoint = 800;

  const createStructure = (x, widgetData, windowSize, breakpoint) => {
    const { Title: widgetTitle, URL: widgetLink, ImageWithPath: widgetImage } = widgetData;
    const widgetImgAttribute = `data-background-image="${widgetImage}" style="background-image:url('${widgetImage}')" data-loaded="true" aria-label="${widgetTitle}"`;

    if (windowSize >= breakpoint) {
      return `
        <div class="card-widget-item mobile card-item${x + 1}${!widgetLink ? ' void-link' : ''}">
          <div class="outer-container">
            <div class="img-bg lozad" ${widgetImgAttribute}>
              <div class="card-content">
                <div class="content-wrap">
                  <span>${widgetTitle}</span>
                  ${widgetLink ? `<div class="btn-container"><a href='${widgetLink}' class="button">More</a></div>` : ''}
                </div>
              </div>
            </div>
          </div>
        </div>
      `;
    } else {
      return `
        <a class="card-widget-item mobile card-item${x + 1} ${!widgetLink ? 'void-link' : ''}" ${widgetLink ? `href="${widgetLink}"` : ''}>
          <div class="outer-container">
            <div class="img-bg lozad" ${widgetImgAttribute}>
              <div class="card-content">
                <span>${widgetTitle}</span>
              </div>
            </div>
          </div>
        </a>
      `;
    }
  };

  const applyAosAttributes = (element, index) => {
    $(element).attr({
      'data-aos': 'flip-right',
      'data-aos-easing': 'ease-in-out',
      'data-aos-duration': '400',
      'data-aos-delay': (index + 1) * 300,
      'data-aos-once': 'true',
      'data-aos-offset': '200',
    });
  };

  const handleHoverIn = function (element) {
    setTimeout(() => {
      $(element).parents('.card-widget-item').removeClass('hover-out').addClass('hover-in');
    }, 200);
  };

  const handleHoverOut = function (element) {
    setTimeout(() => {
      $(element).parents('.card-widget-item').removeClass('hover-in').addClass('hover-out');
      setTimeout(() => {
        $(element).parents('.card-widget-item').removeClass('hover-out');
      }, 300);
    }, 200);
  };

  const handleHoverEffects = (element) => {
    $(element).hover(
      function () {
        handleHoverIn(this);
      },
      function () {
        handleHoverOut(this);
      },
    );
  };

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,

    cardWidgetLoaded: function (data) {
      const widgetItems = data.items.length;

      if (widgetItems >= 1) {
        $(`#${widgetName} .card-widget-item`).each(function (x) {
          const newStructure = createStructure(x, data.items[x], windowSize, breakpoint);
          $(this).replaceWith(newStructure);
        });

        $(`#${widgetName} .card-widget-item`).each(function (x) {
          applyAosAttributes(this, x);
        });

        $(`#${widgetName} .card-widget-item:not(.void-link)`)
          .find('.content-wrap')
          .each(function () {
            handleHoverEffects(this);
          });
      } else {
        $('.tier-3-container').remove();
      }
    },

    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: ['all'],
    maxItemsVisible: 5,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true,
  });
}
